import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { Badge, Box, ButtonBase } from "@mui/material";
import { styled } from '@mui/material/styles';
import { Chat as ChatIcon, Delete } from "@mui/icons-material";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import SubscriptionRequired from "../SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'blue',
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}))(Tooltip);

const styles = muiBaseTheme => ({
  card: {
    maxWidth: 300,
    margin: "auto",
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  media: {
    paddingTop: "50.25%"
  },
  content: {
    textAlign: "center",
    padding: muiBaseTheme.spacing.unit * 2,
    textAlign: 'center',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    margin: `${muiBaseTheme.spacing.unit * 2}px 0`
  },
  heading: {
    fontWeight: "bold"
  },
  subheading: {
    lineHeight: 1.1,
  },
  avatar: {
    backgroundColor: "#80d4ff",
    color: "black",
    display: "inline-block",
    border: "2px solid white",
    "&:not(:first-of-type)": {
      marginLeft: -muiBaseTheme.spacing.unit
    }
  },
  actionArea: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  }
});

const colors = [
  "#bff603", "yellow", "#80d4ff", "orange",
  "#ff8b94", "#d3ffce", "#9bb7d4", "#ffdb58",
  "#f1a7fe", "#ff6961", "#ffb347", "#add8e6",
  "#a0bfe6", "#89cff0", "#4f86f7", "#67e6ec",
  "#7fffd4", "#77dd77", "#b19cd9", "#ff9999"
];

// Custom ButtonBase to override ripple style
const RectangularButtonBase = styled(ButtonBase)(({ theme }) => ({
  borderRadius: 0,
  '& .MuiTouchRipple-root': {
    borderRadius: 0,
  },
  width: '100%',
  height: '100%',
}));

function App({ classes, teamdata: detail, grpData, deleteMember, openChat }) {

  const letterToColorIndex = (letter) => {
    const lowercaseLetter = letter.toLowerCase();
    const charCode = lowercaseLetter.charCodeAt(0) - 97;
    return charCode % colors.length;
  };

  const colorIndex = letterToColorIndex(detail.name.charAt(0));

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: detail.status === 'Online' ? '#44b700' : '#d3d6db',
      color: detail.status === 'Online' ? '#44b700' : '#d3d6db',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: detail.status === 'Online' ? 'ripple 1.2s infinite ease-in-out' : '',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }));

  const [subReqOpen, setSubReqOpen] = useState(false)
  const accessToChatScreen = useCheckSubscriptionPlanAccess("Chat")

  const handleOpenChat = () => {
    // if (!accessToChatScreen) {
    //   setSubReqOpen(true)
    // } else {
    // openChat()
     window.location.href = `/chat`;
    // }
  }

  return (
    <div className="res-Team-card teamcard DocumentCardHover" >
      <SubscriptionRequired open={subReqOpen} setOpen={setSubReqOpen} />
      <Card className={classes.card} style={{ height: 220, marginBottom: "15px", border: "1px solid blue", borderRadius: "10px" }} id="tapp">
        <CardContent className={classes.content} style={{ height: 170 }}>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            variant="dot"
            className="teamDPs"
          >
            <Avatar
              style={{
                backgroundColor: `${colors[colorIndex]}`,
                color: "black",
                width: 54, height: 54,
                border: "4px solid white",
                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)"
              }}
            >
              <h5
                style={{ marginTop: "4px" }}
                data-toggle="tooltip"
                title={detail.name}
              >
                {detail.name.charAt(0).toUpperCase()}
              </h5>
            </Avatar>
          </StyledBadge>

          <Typography
            className={"MuiTypography--heading"}
            variant={"h6"}
            gutterBottom
            id="teamMemName"
            sx={{ mt: 1, mb: 1 }}
          >
            {detail.name}
          </Typography>

          {/* Phone number with icon */}
          <Box sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            mb: 0.5
          }}>
            <PhoneIcon sx={{ fontSize: 14, color: 'rgba(35, 35, 246, 0.85)' }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'monospace',
                fontSize: '0.8rem',
                color: 'rgba(0, 0, 0, 0.7)',
                textAlign: 'center'
              }}
            >
              {detail.mobile || "+91 xxxxxxxxxx"}
            </Typography>
          </Box>

          {/* Email with icon */}
          <Box sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5
          }}>
            <EmailIcon sx={{ fontSize: 14, color: 'rgba(35, 35, 246, 0.85)' }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: '0.8rem',
                color: 'rgba(0, 0, 0, 0.7)',
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '200px'
              }}
            >
              {detail.email}
            </Typography>
          </Box>
        </CardContent>

        {/* Action Buttons Area */}
        <Box
          display='flex'
          flexDirection='row'
          alignContent='center'
          alignItems='center'
          style={{ borderTop: "1px solid #D3D3D3", height: '48px' }}
        >
          {/* Chat Button Area */}
          <RectangularButtonBase
            onClick={handleOpenChat}
            style={{
              borderRight: "1px solid #D3D3D3",
              width: "50%",
              height: "100%"
            }}
          >
            <div className={classes.actionArea}>
              <LightTooltip title="ChatBox">
                <Badge badgeContent={detail.unreadCount} color="secondary">
                  <ChatIcon
                    color="primary"
                    className="fa fa-commenting"
                    style={{ fontSize: "19px" }}
                    aria-hidden="true"
                    data-placement="right"
                    data-dismiss="modal"
                  />
                </Badge>
              </LightTooltip>
            </div>
          </RectangularButtonBase>

          {/* Remove Member Button Area */}
          {/* <RectangularButtonBase
            onClick={deleteMember}
            style={{ width: "50%" }}
          >
            <div className={classes.actionArea}>
              <LightTooltip title="Remove Member">
                <svg
                  style={{ color: "red", fontSize: "19px" }}
                  aria-hidden="true"
                  data-placement="right"
                  data-dismiss="modal"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </LightTooltip>
            </div>
          </RectangularButtonBase> */}
          <RectangularButtonBase
            onClick={deleteMember}
            style={{ width: "50%" }}
          >
            <div className={classes.actionArea}>
              <LightTooltip title="Remove Member">
                <Delete style={{ color: "red", fontSize: "19px" }} />
              </LightTooltip>
            </div>
          </RectangularButtonBase>
        </Box>
      </Card>
    </div>
  );
}

export default withStyles(styles)(App);
